import {digg} from "diggerize"

const localeToCountryCode = {
  "da": "Danish",
  "en": "English",
  "no": "Norwegian",
  "se": "Swedish"
}

export default class Locales {
  /**
   *
   * @returns {string[]} The available locales for the application.
   */
  static availableLocales() {
    return ["da", "en", "no", "se"]
  }

  /**
   *
   * @param {string} locale
   * @returns {string} The label for the given locale.
   *
   */
  static labelForLocale(locale) {
    return digg(localeToCountryCode, locale)
  }
}
